import AddIcon from "@mui/icons-material/Add";
import { Box, Button } from "@mui/material";
import type { ICellRendererParams } from "ag-grid-community";
import type { BreakRulePreset } from "@/shared/models/BreakRule";
import type { AddRow } from "../utils/gridRows";

const emptyText = (row: AddRow) => {
	if (row.HasRules) return null;
	if (row.ShiftHours === row.DefaultShiftHours) return "No breaks configured";
	const inherits = `Uses the ${row.DefaultShiftHours}h breaks (line default)`;
	return row.DefaultHasRules ? inherits : `${inherits} — none configured yet`;
};

type Props = ICellRendererParams<AddRow> & {
	onNew: (preset: BreakRulePreset) => void;
};

export const SchemeFooterRow = ({ data, node, onNew }: Props) => {
	if (!data) return null;
	const text = emptyText(data);
	return (
		<Box
			sx={{
				height: "100%",
				display: "flex",
				alignItems: "center",
				gap: 2,
				pl: `calc(var(--ag-cell-horizontal-padding) + ${node.level} * var(--ag-row-group-indent-size) + 28px)`,
			}}
		>
			<Button
				size="small"
				variant="outlined"
				startIcon={<AddIcon />}
				onClick={(e) => {
					e.stopPropagation();
					onNew({ AssetId: data.AssetId, ShiftHours: data.ShiftHours });
				}}
				sx={{ py: 0, minHeight: 24, textTransform: "none" }}
			>
				New {data.ShiftHours}h break
			</Button>
			{text && (
				<Box
					component="span"
					sx={{
						color: "text.secondary",
						fontStyle: "italic",
						fontSize: "0.8125rem",
					}}
				>
					{text}
				</Box>
			)}
		</Box>
	);
};
